import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({selector:'app-qr-self-checkin-venue', templateUrl:'./qr-self-checkin-venue.component.html', standalone:false})
export class QrSelfCheckinVenueComponent {
  constructor(private route: ActivatedRoute) {}
  get targetId(): number { return Number(this.route.snapshot.params.venueId); }
}
